<div class="tech-assign-dialog flex-column">
  <!-- Assign technician header -->
  <div class="tech-assign-dialog-header flex-between-center">
    <div class="flex-start-center">
      <i class="far fa-user-hard-hat font-18 mr-2"></i>
      <p class="mb-0 font-bold">Assign Services</p>
    </div>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <!-- Assign technician body -->
  <div class="tech-assign-dialog-body">
    <!-- All tech selection -->
    <div class="ui-g-12 p-0 flex-start-center mb-2">
      <div class="ui-g-4 ">
        <p class="m-0 font-bold text-truncate" [pTooltip]="order?.title" tooltipPosition="top">
          RO: {{order?.orderStatus? 'Estimate' : 'Invoice'}} (#{{order?.orderStatus? order?.code : order?.invCode}}) -
          {{order?.title}}
        </p>
      </div>

      <div class="ui-g-2">
        <p class="m-0 font-600">Assign all to:</p>
      </div>

      <div class="ui-g-2">
        <app-dropdown theme="primary" placeholder="Primary tech" field="name" styleClassText="font-600"
          styleClassValue="pl-0" styleClassSelectedView="pl-0" scrollHeight="222px" itemWidth="200px"
          [options]="technicians" [fontSize]="14" [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true"
          (appSelect)="handleSelectMultiple('tech', $event)">
          <ng-template let-item appTemplate="item">
            <div class="flex-start-center">
              <span *ngIf="item?.techId !== 'unassigned'" class="tech-initials flex-center-center mr-1">
                {{techInitials[item.techId]?.initials || item.initials}}
              </span>

              <span *ngIf="item?.techId === 'unassigned'" class="tech-initials flex-center-center mr-1">
                <i class="far fa-user-hard-hat"></i>
              </span>

              <span class="text-truncate">
                {{techInitials[item.techId]?.name || item.name}}
              </span>
            </div>
          </ng-template>
        </app-dropdown>
      </div>

      <div class="ui-g-2">
        <app-dropdown theme="primary" placeholder="Helper 1" field="name" styleClassText="font-600"
          styleClassValue="pl-0" styleClassSelectedView="pl-0" scrollHeight="222px" itemWidth="200px"
          [options]="technicians" [fontSize]="14" [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true"
          (appSelect)="handleSelectMultiple('hTechOne', $event)">
          <ng-template let-item appTemplate="item">
            <div class="flex-start-center">
              <span *ngIf="item?.techId !== 'unassigned'" class="tech-initials flex-center-center mr-1">
                {{techInitials[item.techId]?.initials || item.initials}}
              </span>

              <span *ngIf="item?.techId === 'unassigned'" class="tech-initials flex-center-center mr-1">
                <i class="far fa-user-hard-hat"></i>
              </span>

              <span class="text-truncate">
                {{techInitials[item.techId]?.name || item.name}}
              </span>
            </div>
          </ng-template>
        </app-dropdown>
      </div>

      <div class="ui-g-2">
        <app-dropdown theme="primary" placeholder="Helper 2" field="name" styleClassText="font-600"
          styleClassValue="pl-0" styleClassSelectedView="pl-0" scrollHeight="222px" itemWidth="200px" hPosition="left"
          [options]="technicians" [fontSize]="14" [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true"
          (appSelect)="handleSelectMultiple('hTechTwo', $event)">
          <ng-template let-item appTemplate="item">
            <div class="flex-start-center">
              <span *ngIf="item?.techId !== 'unassigned'" class="tech-initials flex-center-center mr-1">
                {{techInitials[item.techId]?.initials || item.initials}}
              </span>

              <span *ngIf="item?.techId === 'unassigned'" class="tech-initials flex-center-center mr-1">
                <i class="far fa-user-hard-hat"></i>
              </span>

              <span class="text-truncate">
                {{techInitials[item.techId]?.name || item.name}}
              </span>
            </div>
          </ng-template>
        </app-dropdown>
      </div>
    </div>

    <!-- Service table header -->
    <div class="ui-g-12 p-0 flex-start-start service-header mb-2">
      <div class="ui-g-4 ">
        <p class="m-0 font-600">Services</p>
      </div>

      <div class="ui-g-2">
        <p class="m-0 font-600">Status</p>
      </div>

      <div class="ui-g-2 flex-column flex-center-start">
        <p class="m-0 font-600 font-13">Primary tech</p>
        <p class="m-0 font-11">Current primary tech</p>
      </div>

      <div class="ui-g-2 flex-column flex-center-start">
        <p class="m-0 font-600 font-13">Helper 1</p>
        <p class="m-0 font-11">Current helper 1</p>
      </div>

      <div class="ui-g-2 flex-column flex-center-start">
        <p class="m-0 font-600 font-13">Helper 2</p>
        <p class="m-0 font-11">Current helper 2</p>
      </div>
    </div>

    <!-- Service table body -->
    <app-multi-tech-selection-row [currentLang]="currentLang" *ngFor="let service of order?.services"
      class="ui-g-12 p-0 flex-start-start multi-tech-row"
      [ngClass]="{'highlighted-service': service?._id === serviceId, 'disabled': !service?.isActive}"
      [isServiceAssignDisabled]="order?.isArchived || !service?.isActive" [serviceTech]="currentTech[service?._id]"
      [errors]="errors[service?._id]" [service]="service" [technicians]="technicians" [techInitials]="techInitials"
      (appTechSelect)="handleTechSelect($event)">
    </app-multi-tech-selection-row>
  </div>

  <!-- Assign technician footer -->
  <div class="tech-assign-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>

    <button class="btn btn-primary btn-submit" [disabled]="isProcessing || isSubmitting" (click)="handleSubmit()">
      Save
      <i class="fal fa-spinner rotate" *ngIf="isSubmitting"></i>
    </button>
  </div>
</div>
